import { render, staticRenderFns } from "./GroupsCalendar.vue?vue&type=template&id=de349020&"
import script from "./GroupsCalendar.vue?vue&type=script&lang=js&"
export * from "./GroupsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports